import { render, staticRenderFns } from "./CalendarGeneral.vue?vue&type=template&id=608c24ca"
import script from "./CalendarGeneral.vue?vue&type=script&lang=js"
export * from "./CalendarGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports